import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import navbar from "@/components/probaworkflows_base_components/Navbar/NavBar.vue";
import ProbaWorkflowsSidebar from '@/components/probaworkflows_base_components/ProbaWorklfowsSidebar/ProbaWorkflowsSidebar.vue';
import { ASSIGN_PROJECTS_TO_ROLE, CREATE_ROLE_URL, GET_COMPANIES, get_headers, GET_PROJECTS_ASSIGNED_TO_ROLE, get_token, ROLES_URL, verify_super_user_status } from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { validate_non_empty_string } from '@/utils/validations/validate_inputs';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Swal from 'sweetalert2';

export default {
  name: 'RolesManagement',
  components: {
    ProbaWorkflowsSidebar,
    navbar,
    GlobalTable,
  },
  mixins: [alert_mixin],
  data: () => ({
    token: get_token(),
    headers: get_headers(),
    role_name:'',
    role_description:'',
    roles: [],
    roles_headers:[],
    roles_two: [
              { number: 1, Permission: 'Property' },
              { number: 2, Permission: 'Other investment' }
          ],
    roles_management_config: {
      icon_map: {
        dashboard: "fa-user",
        compliance: "fa-user-shield",
        pending_application: "bi bi-shield-shaded",
        logout: "fa-sign-out-alt"
      },
      text_map: {
        dashboard_title: "Management",
        dashboard: "Users",
        compliance: "Roles",
        pending_application: "Permission",
        logout: "Logout"
      }
    },
    is_managing_role: false,
      current_role: {},
      is_role_permission_active: true, // To track the active tab
      is_role_user_active: false, // To track the active tab
    role_id: null,
    project_ids: [],
    project_list: [],
    assign_count: 0,
    unassign_count: 0,
    project_id: Number(sessionStorage.getItem('project_id')) || null,
    delete_only: true,
    is_super_user: false,
  }),

  async mounted() {
    this.is_super_user = await verify_super_user_status();

    if (this.project_id === null) {
      this.delete_only = false;
    }
    this.fetch_roles();
    this.get_projects();
  },

  methods: {
    async fetch_roles() {
      this.roles = [];
      try {
        const response = await axios.get(ROLES_URL, {
          headers: this.headers,
          params: {
            project_id: this.project_id
          }
        });

        this.roles = response.data.data.map(role => ({
          id: role.id,
          role: role.role,
          description: role.description,
        }));

        if (this.roles.length > 0) {
          this.roles_headers = Object.keys(this.roles[0]);
        }

      } catch (error) {
        this.show_error('Error fetching roles: ' + error.message);
      }
    },

    add_role() {
      if (!validate_non_empty_string(this.role_name)) {
        this.show_error('Role name cannot be empty');
        return;
      }

      const payload = {
        role_name: this.role_name,
        role_description: this.role_description || null,
        project_id: this.project_id
      };

      axios
        .post(CREATE_ROLE_URL, payload, { headers: this.headers })
        .then((response) => {
          const msg = response.data?.message || "Role created successfully";

          this.fetch_roles();
          this.show_success(msg);
          this.close_modal('create_role');
          this.role_name = '';
          this.role_description = '';
        })
        .catch((error) => {
          const msg =
            error.response?.data?.message ||
            error.response?.data?.error ||
            "An unexpected error occurred.";

          this.show_error(msg);
        });
    },


    manage_role(role) {
      this.is_managing_role = true;
      this.current_role = { ...role };
    },

    get_projects() {
      this.project_list = [];
      return this.show_loader("Loading companies...")
        .then(loader => {
          return axios.get(GET_COMPANIES, {
            headers: this.headers
          })
            .then(response => {
              const parsed_response = JSON.parse(response.data);
              if (parsed_response.data && parsed_response.data.length > 0) {
                const projects = parsed_response.data;
                this.project_list = projects.map(project => ({
                  id: project.id,
                  name: project.name,
                  description: project.project_description,
                }));
                this.project_headers = Object.keys(this.project_list[0])
              }

              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error getting companies: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    get_assignments(role) {
      this.role_id = role;
      return this.show_loader("Loading assignments...")
        .then(loader => {
          const data = {
            role_id: role
          }
          return axios.post(GET_PROJECTS_ASSIGNED_TO_ROLE, data, {
            headers: this.headers,
          })
            .then(response => {
              response = response.data;
              this.project_ids = [];

              if (response.data && Array.isArray(response.data)) {
                // Extract all project IDs from the response array
                this.project_ids = response.data.map(item => item.project);
              }

              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error getting assignments: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    assign_projects_to_role() {
      return this.show_loader("Updating role assignments...")
        .then(loader => {
          const data = {
            role_id: this.role_id,
            project_ids: this.project_ids
          }
          return axios.post(ASSIGN_PROJECTS_TO_ROLE, data, {
            headers: this.headers,
          })
            .then(() => {
              switch (true) {
                case this.assign_count > 0 && this.unassign_count > 0:
                  this.show_success(
                    `${this.assign_count} Role(s) assigned and ${this.unassign_count} Role(s) unassigned successfully`
                  );
                  break;

                case this.assign_count > 0:
                  this.show_success(
                    "Role(s) assigned successfully"
                  );
                  break;

                case this.unassign_count > 0:
                  this.show_success(
                    "Role(s) unassigned successfully"
                  );
                  break;

                default:
                  this.show_success('No changes made to assignments');
              }
              this.assign_count = 0;
              this.unassign_count = 0;
              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error assigning roles: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    unassign_role_from_project(role_id) {
      return this.show_loader("Deleting role")
        .then(loader => {
          const data = {
            role_id: role_id,
            project_id: this.project_id,
            project_ids: []
          }
          return axios.post(ASSIGN_PROJECTS_TO_ROLE, data, {
            headers: this.headers,
          })
            .then(() => {
              this.fetch_roles();
              this.show_success('Role deleted');
              return this.close_loader(loader);
            })
            .catch(error => {
              this.show_error('Error deleting role: ' + error);
              return this.close_loader(loader);
            });
        });
    },

    toggle_assignment(project_id) {
      if (this.project_ids.includes(project_id)) {
        // Remove it from project_ids
        this.project_ids = this.project_ids.filter(id => id !== project_id);
        this.unassign_count += 1;
      } else {
        // Add it to project_ids if not already there
        this.assign_count += 1;
        this.project_ids.push(project_id);
      }
    },

    manage_role_permissions() {
      this.show_success(`Managing permissions for role.`);
    },
    manage_user_roles() {
      this.show_success(`Managing users assigned to role.`);
    },
    assign_permission() {
      this.show_success(`Assigning new permission to role.`);
    },
    remove_policy() {
      this.show_success('Policy removed successfully');
    },
    delete_role() {
      Swal.fire({
        title: "Are you sure you want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire("Deleted!", 'The role  has been deleted.');
        }
      });
    },

    toggleTab(tab) {
      if (tab === 'permission') {
        this.is_role_permission_active = true;
        this.is_role_user_active = false;
      } else {
        this.is_role_permission_active = false;
        this.is_role_user_active = true;
      }
    },
    go_back_to_company_management(){
      this.$router.push('/company_management');
    }
  },
};
